<template>
  <div class="basic_webtitle height_fill" v-if="$store.state.app.view_pattern === 'pc' && !isInMobile">
    <div class="tooptipPart module_edit_btn">
      <my_hover_btn :tips="$t('widgets_basic_webtitle_index_2907')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
      <my_moduleShow_btn radioName="logoTitleRadio" :title="$t('components_my_moduleshow_btn_index_2368')"></my_moduleShow_btn>
    </div>
    <div class="titleLine height_fill" :class="pc_infor.typeValue" :style="{
        height: module.data.pc_widgets_infor.height + 'px',
        textAlign: pc_infor.fontStyle.custom.textAlign,
      }">
      <div class="imgBox">
        <img id="baseImg" v-if="pc_infor.typeValue !== 'type_0'" class="firstImg baseImgHelper" @load="getImgWidth"
             :src="module.data.listArr.logoUrl ? module.data.listArr.logoUrl : '/static/image/logo.jpg'"/>
      </div>
      <div v-if="pc_infor.typeValue !== 'type_0' && pc_infor.typeValue !== 'type_3'" class="imgPart"
           :title="module.data.listArr.logoTitle"
           :style="{
          marginRight: pc_infor.typeValue === 'type_2' ? pc_infor.marginValue[pc_infor.marginValue.radio_val].value + 'px' : 0,
          marginLeft: pc_infor.typeValue === 'type_3' ? pc_infor.marginValue[pc_infor.marginValue.radio_val].value + 'px' : 0,
          width:pcLogoWidth + 'px',
        }">
        <div class="imgContent" :style="{
          height:pcLogoHeight+'px'
        }">
          <set_link class="linkPart" :sendData="module.data.listArr.link_pic"></set_link>
          <img class="logoImg"
               :src="module.data.listArr.logoUrl ? module.data.listArr.logoUrl : '/static/image/logo.jpg'"
               :title="module.data.listArr.logoTitle"/>
        </div>
      </div>
      <div class="webtitle" v-if="pc_infor.typeValue !== 'type_1'" :style="{
          lineHeight: pc_infor.fontStyle.custom.lineHeight === $t('view_back_top_edit_103') ? '' : pc_infor.fontStyle.custom.lineHeight + 'px',
          fontSize:pc_infor.fontStyle.custom.fontSize + 'px',
          fontFamily: pc_infor.fontStyle.custom.fontFamily,
          textAlign: 'left',
          background: pc_infor.background,
          fontWeight: pc_infor.fontStyle.custom.fsWeight,
          fontStyle: pc_infor.fontStyle.custom.fsItalics,
          textDecoration: pc_infor.fontStyle.custom.fontUnderline,
        }">
        <div :style="{
            lineHeight: pc_infor.fontStyle.custom.lineHeight === $t('view_back_top_edit_103') ? '' : pc_infor.fontStyle.custom.lineHeight + 'px'
          }"
             class="titleWord">
          <div class="titlePart basic_webtitle_content">
            <div class="contentPart" @dblclick="clickTime">
              <set_link class="linkPart" :sendData="module.data.listArr.link_text"
                        v-if="module.widgets_id !== editID"></set_link>
              <div class="edit-div titleEdit" :contenteditable="true" :id="'editDiv' + module.widgets_id"
                   @mousedown.stop @focus="isLocked = true" @blur="isLocked = false" @input="changeText"
                   v-html="module.data.listArr.title"
                   :style="{
                  height: module.data.pc_widgets_infor.height + 'px',
                  lineHeight: pc_infor.fontStyle.custom.lineHeight === $t('view_back_top_edit_103') ? '' : pc_infor.fontStyle.custom.lineHeight + 'px',
                  fontSize:pc_infor.fontStyle.custom.fontSize + 'px',
                  textAlign: 'left',
                  fontFamily: pc_infor.fontStyle.custom.fontFamily,
                  fontWeight: pc_infor.fontStyle.custom.fsWeight,
                  fontStyle: pc_infor.fontStyle.custom.fsItalics,
                  textDecoration: pc_infor.fontStyle.custom.fontUnderline,
                  webkitBackgroundClip: 'text',
                  webkitTextFillColor: pc_infor.fontStyle.custom.pattern == 'linear_gradient' ? 'transparent' : '',
                  color: pc_infor.fontStyle.custom.pattern == 'pure_color' ? pc_infor.fontStyle.custom.titleColor : '',
                  backgroundImage:
                    pc_infor.fontStyle.custom.pattern == 'linear_gradient'
                      ? 'linear-gradient(' +
                        pc_infor.fontStyle.custom.linear_gradient.deg +
                        'deg,' +
                        pc_infor.fontStyle.custom.linear_gradient.start_color +
                        pc_infor.fontStyle.custom.linear_gradient.start_pointer +
                        '%,' +
                        pc_infor.fontStyle.custom.linear_gradient.end_color +
                        pc_infor.fontStyle.custom.linear_gradient.end_pointer +
                        '%)'
                      : ''
                }"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pc_infor.typeValue == 'type_3'" class="imgPart" :title="module.data.listArr.logoTitle" :style="{
          marginRight: pc_infor.typeValue === 'type_2' ? pc_infor.marginValue[pc_infor.marginValue.radio_val].value + 'px' : 0,
          marginLeft: pc_infor.typeValue === 'type_3' ? pc_infor.marginValue[pc_infor.marginValue.radio_val].value + 'px' : 0,
          width:pcLogoWidth + 'px',
        }">

        <div class="imgContent" :style="{
            height:pcLogoHeight+'px'
          }">
          <set_link class="linkPart" :sendData="module.data.listArr.link_pic"></set_link>
          <img class="logoImg"
               :src="module.data.listArr.logoUrl ? module.data.listArr.logoUrl : '/static/image/logo.jpg'"
               :title="module.data.listArr.logoTitle"/>
        </div>
      </div>
    </div>
  </div>
  <div class="basic_webtitle" v-else>
    <div class="titleLine" :class="pc_infor.typeValue">
      <div class="imgBox">
        <img id="baseImg" v-if="pc_infor.typeValue !== 'type_0'" class="firstImg" @load="getImgWidth"
             :src="logoSrc"/>
      </div>
      <div v-if="pc_infor.typeValue !== 'type_0'&&pc_infor.typeValue !== 'type_3'" class="imgPart" :style="{
          height: '50px',
          marginTop:'0',
          width:mbLogoWidth + 'px',
          marginRight: pc_infor.typeValue === 'type_2' ? '10px' : 0,
          marginLeft: pc_infor.typeValue === 'type_3' ? '10px' : 0
        }">

        <div class="imgContent">
          <set_link class="linkPart" :sendData="module.data.listArr.link_pic"></set_link>
          <img class="logoImg"
               :src="logoSrc"
               :title="module.data.listArr.logoTitle"/>
        </div>
      </div>

      <div class="webtitle" v-if="pc_infor.typeValue !== 'type_1'" :style="{
          width: 'unset',
          lineHeight: '50px',
          fontSize:20 + 'px',
          fontFamily: pc_infor.fontStyle.custom.fontFamily,
          background: pc_infor.fontStyle.custom.background,
          fontWeight: pc_infor.fontStyle.custom.fsWeight,
          fontStyle: pc_infor.fontStyle.custom.fsItalics,
          textDecoration: pc_infor.fontStyle.custom.fontUnderline,
        }">
        <div :style="{
            lineHeight: '50px'
          }" class="titleWord">
          <div class="titlePart basic_webtitle_content">
            <set_link class="linkPart" :sendData="module.data.listArr.link_text"
                      v-if="module.widgets_id !== editID"></set_link>
            <div class="titleEdit edit-div" v-html="module.data.listArr.title" :style="{
                position: 'relative',
                overflow: 'hidden',
                height: '50px',
                lineHeight: '50px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                fontSize:$store.state.myRender.common.mb_header_nav_title[$store.state.myRender.common.mb_header_nav_title.radio_val].fontSize + 'px',
                fontFamily: pc_infor.fontStyle.custom.fontFamily,
                textAlign: 'left',
                fontWeight: pc_infor.fontStyle.custom.fsWeight,
                fontStyle: pc_infor.fontStyle.custom.fsItalics,
                textDecoration: pc_infor.fontStyle.custom.fontUnderline,
                webkitBackgroundClip: 'text',
                webkitTextFillColor: pc_infor.fontStyle.custom.pattern == 'linear_gradient' ? 'transparent' : '',
                color: pc_infor.fontStyle.custom.pattern == 'pure_color' ? pc_infor.fontStyle.custom.titleColor : '',
                backgroundImage:
                  pc_infor.fontStyle.custom.pattern == 'linear_gradient'
                    ? 'linear-gradient(' +
                      pc_infor.fontStyle.custom.linear_gradient.deg +
                      'deg,' +
                      pc_infor.fontStyle.custom.linear_gradient.start_color +
                      pc_infor.fontStyle.custom.linear_gradient.start_pointer +
                      '%,' +
                      pc_infor.fontStyle.custom.linear_gradient.end_color +
                      pc_infor.fontStyle.custom.linear_gradient.end_pointer +
                      '%)'
                    : ''
              }">

            </div>
          </div>
        </div>
        <!-- <i>{{module.data.listArr.title}}</i> -->
      </div>
      <div v-if="pc_infor.typeValue == 'type_3'" class="imgPart" :style="{
          height: '50px',
          marginTop:'0',
          width:mbLogoWidth + 'px',
          marginRight: pc_infor.typeValue === 'type_2' ? '10px' : 0,
          marginLeft: pc_infor.typeValue === 'type_3' ? '10px' : 0
        }">

        <div class="imgContent">
          <set_link class="linkPart" :sendData="module.data.listArr.link_pic"></set_link>
          <img class="logoImg"
               :src="module.data.listArr.logoUrl ? module.data.listArr.logoUrl : '/static/image/logo.jpg'"
               :title="module.data.listArr.logoTitle"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import logo from '@/assets/image/logo.jpg';

export default {
  name: 'basic_webtitle',
  data() {
    return {
      imgLogo: '',
      timer: null,
      isLocked: false,
      pcLogoWidth: 0,
      pcLogoHeight: 0,
      mbLogoWidth: 0,
      mbLogoHeight: 0,
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    },
    isInMobile: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLocked(val) {
      let htmlWord = $(`#u${this.module.widgets_id} .edit-div`).html();
      if (htmlWord === i18n.t('widgets_basic_webtitle_index_2908')) {
        this.module.data.listArr.title = '';
      } else if (!htmlWord) {
        this.module.data.listArr.title = i18n.t('widgets_basic_webtitle_index_2908');
      } else {
        this.module.data.listArr.title = htmlWord;
      }
      if (val) {
        var range = document.createRange();
        range.selectNodeContents(document.getElementById('editDiv' + this.module.widgets_id));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      } else if (!val) {
        window.getSelection().removeAllRanges();
        $('#u' + this.module.widgets_id)
          .find('.contentPart')
          .removeClass('focusDiv');
        // this.templet.dialog_close()
      }
    },
    'module.data.pc_infor': {
      handler: function (val) {
        this.$nextTick(() => {
          this.getImgWidth()
        });
      },
      deep: true
    },
    'pc_infor.typeValue': {
      handler: function (val) {
        this.$nextTick(() => {
          this.getImgWidth()
        });
      },
      deep: true
    },
    'module.data.listArr': {
      handler: function (val) {
        this.$nextTick(() => {
          this.getImgWidth()
        });
      },
      deep: true
    }
  },
  computed: {
    pc_infor() {
      const pc_infor = this.module.data.pc_widgets_infor;
      return pc_infor;
    },
    editID() {
      return this.$store.state.app.module_Data ? this.$store.state.app.module_Data.widgets_id : 0;
    },
    logoSrc() {
      // 新增需求 如果导航选择的是有logo的样式，就显示导航里的logo，如果导航选择的是没有logo的样式，就显示之前的
      let navBar = this.getNavBarData()

      if (navBar && navBar.data.pc_widgets_infor.showLogo === 'true') {
        return navBar.data.listArr.logoUrl || '/static/image/logo.jpg'
      } else {
        return this.websiteLogoSrc
      }
    },
    websiteLogoSrc() {
      return this.module.data.listArr.logoUrl || '/static/image/logo.jpg'
    }
  },
  methods: {
    getImgWidth(e) {
      let pcHeight = this.module.data.pc_widgets_infor.height
      let mbHeight = 40
      let imgHeight = $("#baseImg").height()
      let imgWidth = $("#baseImg").width()
      let navBar = this.getNavBarData()
      let nowPcHeight = imgHeight * (pcHeight / imgHeight)
      let nowPcWidth = imgWidth * (pcHeight / imgHeight)
      let nowMbWidth = imgWidth * (mbHeight / imgHeight)
      let nowMbHeight = mbHeight * (mbHeight / imgHeight)
      this.pcLogoWidth = nowPcWidth > imgWidth ? imgWidth : nowPcWidth

      this.pcLogoHeight = nowPcHeight
      this.mbLogoWidth = nowMbWidth > imgWidth ? imgWidth : nowMbWidth
      this.mbLogoHeight = nowMbHeight
      this.module.data.pc_widgets_infor.pcLogoHeight = this.pcLogoHeight
      this.module.data.pc_widgets_infor.pcLogoWidth = this.pcLogoWidth
      this.module.data.pc_widgets_infor.mbLogoWidth = this.mbLogoWidth
      this.module.data.pc_widgets_infor.mbLogoHeight = this.mbLogoHeight
      if (this.pc_infor.typeValue !== 'type_0') {
        // let width = 'calc(100% - ' + (parseInt(this.pc_infor.marginValue[this.pc_infor.marginValue.radio_val].value) + parseInt(this.pcLogoWidth)) + 'px)'
        // $(`#u${this.module.widgets_id} .webtitle`).css('width', width)
      } else {
        $(`#u${this.module.widgets_id} .webtitle`).css('width', 'unset')
      }
    },
    changeStyle(tabName) {
      this.templet.changeStyle(this.module, tabName);
    },
    toAnchor(type, id, path) {
      this.templet.active_anchor(type, id, path);
    },
    clickTime() {
      let that = this;
      if (this.module.widgets_id === this.editID) {
        return false;
      }
      $('#u' + that.module.widgets_id)
        .find('.contentPart')
        .addClass('focusDiv');
      var range = document.createRange();
      range.selectNodeContents(document.getElementById('editDiv' + this.module.widgets_id));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    },
    falseClick() {
      return false;
    },
    changeLink() {
      return false;
    },
    textClickEvent() {
      $('.basic_webtitle .edit_div').click();
      return false;
    },
    saveWrods(data) {
      this.module.data.listArr.title = data;
    },
    changeText(val) {
      let htmlWord = $(`#u${this.module.widgets_id} .edit-div`).html();
    },
    getNavBarData() {
      let rows = this.$store.state.myRender.header
      let basicNavBar = null
      rows.forEach(row => {
        row.children.forEach(col => {
          col.children.forEach(module => {
            if (module.name === 'basic_navbar') {
              basicNavBar = module
            }
          })
        })
      })
      return basicNavBar
    }
  },
  mounted() {
    let basic_navbar = this.getNavBarData()
    this.module.data.listArr.logoUrl ? (this.imgLogo = this.module.data.listArr.logoUrl) : (this.imgLogo = logo);
  },
  created() {
    this.templet.checkfontStyle(this.module.data.pc_widgets_infor)
  }
};
</script>

<style lang="scss" scoped>
.mobile_header {
  .titleLine {
    .imgPart {
      .imgContent {
        height: 40px;
        width: 100%;

        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
}

.titleLine {
  text-align: center;

  .logoImg {
    width: 100%;
    height: auto;
    max-height: 100%;
    max-width: 100%;
    margin: auto;
  }

  .imgPart {
    display: inline-block;
    min-width: 30px;
    min-height: 30px;
    position: relative;
    vertical-align: middle;
    max-width: 100%;

    .imgContent {
      display: table-cell;
      vertical-align: middle;
      white-space: normal;
    }
  }

  .webtitle {
    display: inline-block;
    vertical-align: top;
    overflow: hidden;
    cursor: text;
    min-width: 10px;
    height: 100%;
    // max-width: 50%;

    .titlePart {
      height: 100%;
    }

    .titleWord {
      height: 100%;
    }

    .titleEdit {
      cursor: text;
      min-width: 10px;
      overflow: hidden;
      display: table-cell;
      vertical-align: middle;
      white-space: normal;
    }
  }
}

.basic_webtitle:hover {
  .tooptipPart {
    display: block;
  }
}

.titleLine.type_1,
.titleLine.type_2,
.titleLine.type_3 {
  overflow: hidden;
  font-size: 0;
  white-space: nowrap;
}

.titleLine.type_0 .imgPart {
  display: none;
}

.titleLine.type_1 .webtitle {
  display: none;
}

.titleLine.type_2 .logoImg {
}

.titleLine.type_3 .logoImg {
}

.contentPart {
  position: relative;
  width: 100%;
  height: 100%;
}

.contentPart.focusDiv {
  border: 1px dashed #5874d8;
  cursor: text;
}

.pc_pattern .basic_webtitle {
  .titleLine.type_1 {
    .imgPart {
      width: 100%;
    }
  }
}

.mobile_header .titleLine {
  line-height: 50px;
  height: 50px;
}

.titleLine.type_1 .imgPart {
  width: 100%;
}

.titleLine.type_0 .webtitle {
  max-width: 100%;
}

.mb_pattern .titleLine .webtitle .titleEdit {
  display: block;
  white-space: normal !important;
}

.basic_webtitle .firstImg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  width: auto !important;
  max-width: unset;
}

.basic_webtitle .imgBox {
  overflow: hidden;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_webtitle/index.vue